// extracted by mini-css-extract-plugin
export default {"menu":"Navbars_menu__jWxOT"};